import React from 'react';
import './App.css';
import ImportForm from './components/ImportForm/ImportForm';

const App = () => (
    <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2">
            <div>
                <div className="md:min-h-screen bg-gray-50 flex flex-col justify-center align-top py-12 px-8">
                    <div className="mx-auto w-full max-w-md text-gray-100">
                        <img
                            className="w-auto mb-8"
                            src="https://api.flotiq.com/image/0x0/_media-ab51da99-44fa-46a0-87fb-594f6bf27b46.svg"
                            alt="Flotiq"
                        />
                        <h1 className="title-font text-3xl mb-4 font-medium">
                            Import data from WordPress
                        </h1>
                        <p className="leading-normal">
                            Replacing WordPress is one of the most common use cases for Headless CMS,
                            and for good reasons. Let&apos;s take a look at how easy it&apos;s going to be.
                            You can import
                            {' '}
                            <span className="font-bold">tags</span>
                            ,
                            <span className="font-bold"> categories</span>
                            ,
                            <span className="font-bold"> media</span>
                            ,
                            <span className="font-bold"> posts</span>
                            , and
                            <span className="font-bold"> pages</span>
                            ,
                            from WordPress to Flotiq.
                            Simply, fill the required data and click the &quot;Start import&quot; button.
                        </p>
                    </div>
                </div>
            </div>
            <div>
                <div className="md:min-h-screen bg-gray-50 flex flex-col justify-center pb-8 md:pb-0 px-8">
                    <ImportForm />
                </div>
            </div>
        </div>
    </div>
);

/**
 * Checking pogress
 <div className={styles.column}>
 <h2>Your individual request code: </h2>
 <input
 className={styles.input}
 type="text"
 value={userRequestCode}
 onChange={(event) => {
            SetUserRequestCode(event.target.value);
          }}
 />
 <br />
 <button
 onClick={async () => {
            SetIsFetching(true);
            SetProgress(await checkStatus(userRequestCode));
            SetIsFetching(false);
          }}
 >
 Check status
 </button>
 </div>
*/

export default App;
